/**
 * Sentinel error message used by safe-mutation wrappers (`useSafeAction`,
 * `usePageSubmit`). When a mutation handler catches an error, surfaces it via
 * `errorPanel`, and rethrows for control flow, it must rethrow `new Error(HANDLED_ERROR_MESSAGE)`.
 * The outer safe wrapper detects this sentinel and swallows it (no double-report,
 * no unexpected-error path). Any other thrown value is treated as unexpected.
 */
export const HANDLED_ERROR_MESSAGE = 'Operation failed for unknown reason. Please contact support.';
